import { Component, computed, inject, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IUltrasonicReadings } from '../../models/sensor.model';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { FooterComponent } from '../footer/footer';
import { NavButtonComponent } from '../nav-button/nav-button';
import { NzSwitchComponent } from 'ng-zorro-antd/switch';
import { SpinnerComponent } from '../spinner/spinner';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CardComponent } from '../card/card';

@Component({
  selector: 'app-ultrasonic',
  imports: [
    FormsModule,
    FooterComponent,
    NavButtonComponent,
    NzSwitchComponent,
    SpinnerComponent,
    NzInputModule,
    NzIconModule,
    CardComponent,
  ],
  templateUrl: 'ultrasonic.html',
  styleUrls: ['./ultrasonic.scss'],
})
export class UltrasonicComponent {
  private ui = inject(UiService);
  public i18n = inject(I18nService);
  saving = false;

  navHeader = output<number>();
  navBack = output<void>();
  navExit = output<void>();
  navContinue = output<IUltrasonicReadings>();
  isMobile = computed(() => this.ui.IsMobile());
  ultraSonicChecked = signal(false);
  decibelRating = signal<number | undefined>(undefined);
  inletTemperature = signal<number | undefined>(undefined);
  outletTemperature = signal<number | undefined>(undefined);
  ultrasonicCheckNote = signal<any>(null);

  showDecibelValidation = signal(false);
  showInletValidation = signal(false);
  showOutletValidation = signal(false);

  readonly decibelMax = 140;
  readonly decibelMin = 1;
  isSensorComplete = computed(() => {
    return (
      this.decibelRating() !== undefined &&
      this.inletTemperature() !== undefined &&
      this.outletTemperature() !== undefined
    );
  });
  toggleChecked() {
    this.ultraSonicChecked.update((v) => !v);
  }

  emitNavContinue() {
    this.saving = true;
    this.navContinue.emit({
      decibelRating: this.decibelRating()!,
      inletTemperature: this.inletTemperature()!,
      outletTemperature: this.outletTemperature()!,
      ultrasonicCheckNote: this.ultrasonicCheckNote(),
    });
  }

  private readonly DECIBEL_MAX = 140;
  private readonly DECIBEL_MIN = 1;

  onDecibelInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitized = input.value.replace(/[^\d]/g, '');
    if (!sanitized) {
      input.value = '';
      this.decibelRating.set(undefined);
      return;
    }
    let value = Number(sanitized);
    if (value > this.DECIBEL_MAX) value = this.DECIBEL_MAX;
    if (value < this.DECIBEL_MIN) value = this.DECIBEL_MIN;
    input.value = String(value);
    this.decibelRating.set(value);
  }

  checkPattern(value: string, type: 'decibel' | 'inlet' | 'outlet') {
    const cleanVal = value.replace(/[.,]/g, '');
    if (cleanVal === '') {
      this.setSignalValue(type, undefined);
      return;
    }

    let num = +cleanVal;
    if (type === 'decibel') {
      num = Math.min(Math.max(num, this.decibelMin), this.decibelMax);
    }
    this.setSignalValue(type, num);
  }

  private setSignalValue(type: string, val?: number) {
    if (type === 'decibel') this.decibelRating.set(val);
    if (type === 'inlet') this.inletTemperature.set(val);
    if (type === 'outlet') this.outletTemperature.set(val);
  }
  isNotDecimal(value: any) {
    return /^-?\d+$/.test(value);
  }

  isInRange(value: number | undefined, min: number, max: number) {
    return !!value && value >= min && value <= max;
  }

  isPositive(value: any) {
    return /^\d+$/.test(value);
  }
}
